export default __webpack_public_path__ + "static/media/image_37.552e805b.png";